export default "__VITE_ASSET__CaEMYB6Y__"